<template>
  <form ref="form" novalidate>
    <slot></slot>
  </form>
</template>

<script>
export default {
  mounted() {
    this.$refs.form.addEventListener('submit', this.onSubmit)
  },
  beforeDestroy() {
    this.$refs.form.removeEventListener('submit', this.onSubmit)
  },
  methods: {
    validate: function() {
      let isValid = true
      let firstInvalid = null

      for (const node of this.$slots.default) {
        const invalid = this.validateNode(node)
        if (invalid) {
          isValid = false
          if (!firstInvalid) firstInvalid = invalid
        }
      }

      if (firstInvalid && firstInvalid.$el) {
        firstInvalid.$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      return isValid
    },
    getChildren(vnode) {
      return vnode.children || (vnode.componentOptions && vnode.componentOptions.children)
    },
    // Returns the first invalid field component, or null if the subtree is valid.
    validateNode(vnode) {
      if (vnode.componentInstance !== undefined && typeof vnode.componentInstance.validate !== 'undefined') {
        return vnode.componentInstance.validate() === true ? null : vnode.componentInstance
      }

      const children = this.getChildren(vnode)
      if (children) {
        let firstInvalid = null
        for (const child of children) {
          const invalid = this.validateNode(child)
          if (invalid && !firstInvalid) firstInvalid = invalid
        }
        return firstInvalid
      }

      return null
    },
    reset: function() {
      this.$slots.default.forEach(vnode => {
        if (vnode.componentInstance !== undefined && typeof vnode.componentInstance.validate !== 'undefined') {
          vnode.componentInstance.reset()
        }
      })

      this.$emit('reset')
    },
    onSubmit: function(e) {
      if (e.preventDefault) e.preventDefault()
      this.$emit('submit')
      return false
    }
  }
}
</script>
